import DodoneChronometer from 'app/dodones/shared/Chronometer'
import DodoneCommentFieldTrigger from 'app/dodones/fields/comment/Trigger'
import DodoneContext from 'app/dodones/Context'
import DodoneGenericShowContext from 'app/dodones/generic/show/Context'
import DodoneGenericStats from 'app/dodones/generic/Stats'
import update from 'immutability-helper'

const StartedGenericBody = ({ attributes, chronometerParameters }) => {
  const { dodone, onTick, updateDodone } = useContext(DodoneContext)
  const { showCommentFieldTrigger } = useContext(DodoneGenericShowContext)

  const onAttributeChanged = useCallback(
    (e) => {
      const nextAttributes = update(attributes, {
        [e.target.name]: { $set: e.target.value }
      })

      setAttributes(nextAttributes)
    },
    [attributes]
  )

  return (
    <>
      <div className="mb-d">
        {!chronometerParameters.hide && (
          <DodoneChronometer
            dodone={dodone}
            onTick={onTick}
            {...chronometerParameters}
          />
        )}
      </div>
      {showCommentFieldTrigger && (
        <div className="mb-d">
          <DodoneCommentFieldTrigger dodone={dodone} />
        </div>
      )}
    </>
  )
}

const FinishedGenericBody = () => {
  const { dodone } = useContext(DodoneContext)

  return (
    <>
      <div className="mb-d">
        <DodoneGenericStats dodone={dodone} />
      </div>
    </>
  )
}

export default ({ attributes, chronometerParameters }) => {
  const { dodone } = useContext(DodoneContext)

  if (dodone.isFinished) return <FinishedGenericBody />
  if (dodone.isStarted)
    return (
      <StartedGenericBody
        attributes={attributes}
        chronometerParameters={chronometerParameters}
      />
    )
  return <></>
}
